export default "__VITE_ASSET__CYLJukTT__"